import {createLeadingSlashUrl} from '@/_application/core/utils/common';
import {ConfigurableProduct, ProductInterface, SimpleProduct} from '@/__generated__/__types__';
import {productPlaceholder} from '@/lib/placeholders';
import {getDiscountPercent} from '@/_application/modules/products/model/price';

export type Product = SimpleProduct | ConfigurableProduct;
type ProductWithSmallImageUrl = ProductInterface & {
    small_image_url?: string;
};

export const getProductItemImage = (product: ProductWithSmallImageUrl) => {
    const {small_image, small_image_url} = product;
    return small_image?.url ?? small_image_url ?? productPlaceholder;
};

export const getProductItemImageLabel = (product: ProductInterface) => {
    const {thumbnail} = product;
    return thumbnail?.label ?? '';
};

export const getProductUrl = (product: Product, isAbsolute: boolean = true) => {
    const {url_key, url_suffix, canonical_url} = product;
    let baseUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? '';

    // Check if the base URL ends with a slash and remove it if it does
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }

    let relativeUrl = `${createLeadingSlashUrl(url_key ?? '')}${url_suffix ?? '.html'}`;
    if (canonical_url && canonical_url !== 'false') {
        relativeUrl = createLeadingSlashUrl(canonical_url);
    }

    return isAbsolute ? `${baseUrl}${relativeUrl}` : `${relativeUrl}`;
};

export const isNewProduct = (product: Product) => {
    const now = new Date();
    if (product?.news_from_date && new Date(product.news_from_date) > now) return false;
    if (product?.news_to_date && new Date(product.news_to_date) < now) return false;
    return product?.new_product;
};

export const isSaleProduct = (product: Product) => {
    const discount = getDiscountPercent(product);
    return discount > 0;
};

export const isHotProduct = (product: Product) => {
    return product?.hot_product;
};

export const isProductHasGift = (product: Product) => {
    return product?.has_gift;
};
